import React from 'react';
import InkLeak from '../component/InkLeak';

const TempPage = () => {
  return (
    <div>
      <h2>h2</h2>
      <InkLeak text='zxNjiftrsu' height={100} />
    </div>
  );
};

export default TempPage;
